import { render, staticRenderFns } from "./RedlightAccusationDamage.vue?vue&type=template&id=03f87528&"
import script from "./RedlightAccusationDamage.vue?vue&type=script&lang=js&"
export * from "./RedlightAccusationDamage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports